/*
 * @Descripttion: descripttion
 * @Author: chaiz(chaiz@dchealth.com)
 * @Date: 2023-08-09 17:04:52
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-08 09:49:51
 */
import { baseUrl } from '../request/url'
export const Config = {
  webTitle:
    baseUrl === '/edc/' ? '过敏性疾病队列研究' : '荨麻疹治疗真实世界研究'
  // webTitle: "过敏性疾病队列研究",
}
